import {WideContent} from "@pg-design/grid-module";
import {mb, mt} from "@pg-design/helpers-css";
import {BrandTenementIcon} from "@pg-design/icons-module";

import {ColumnList} from "../../../../../atoms/ColumnList";
import {ColumnListItem} from "../../../../../atoms/ColumnListItem";
import {InfoPanel} from "../../../../../atoms/InfoPanel";
import {OfferBox} from "../../../../components/offer_box/OfferBox";
import {offerBoxTracking} from "../../../../tracking/offer_box_gtm_events";
import {IOfferListOffer} from "../../../../types/IOfferListOffer";

interface IProps {
    offers: IOfferListOffer[];
    dividerVisible: boolean;
}

export const ArchivedOffersListing = (props: IProps) => {
    return (
        <>
            <WideContent>
                {props.dividerVisible && (
                    <InfoPanel
                        icon={BrandTenementIcon}
                        heading="Zobacz wyprzedane oferty w tej lokalizacji."
                        subHeading="Te nieruchomości znalazły już swoich właścicieli."
                        css={[mt(6), mb(3)]}
                        headingAs="p"
                    />
                )}
            </WideContent>

            <ColumnList>
                {props.offers.map((offer, index) => {
                    return (
                        <ColumnListItem key={offer.id}>
                            <OfferBox
                                isArchived
                                offer={offer}
                                index={index}
                                gtmMeta={{
                                    listName: "Zobacz wyprzedane oferty w tej lokalizacji",
                                    listId: "zobacz_wyprzedane_oferty_w_tej_lokalizacji",
                                    source: "additional",
                                    tileEvents: {
                                        imageClick: offerBoxTracking.gtm.investAdditionalImageClick,
                                        buttonClick: offerBoxTracking.gtm.investAdditionalButtonClick,
                                        linkClick: offerBoxTracking.gtm.investAdditionalLinkClick,
                                        logoClick: offerBoxTracking.gtm.investAdditionalLogoClick
                                    }
                                }}
                            />
                        </ColumnListItem>
                    );
                })}
            </ColumnList>
        </>
    );
};
import {WideContent} from "@pg-design/grid-module";
import {mb, mt} from "@pg-design/helpers-css";
import {BrandTenementIcon} from "@pg-design/icons-module";

import {ColumnList} from "../../../../../atoms/ColumnList";
import {ColumnListItem} from "../../../../../atoms/ColumnListItem";
import {InfoPanel} from "../../../../../atoms/InfoPanel";
import {OfferBox} from "../../../../components/offer_box/OfferBox";
import {offerBoxTracking} from "../../../../tracking/offer_box_gtm_events";
import {IOfferListOffer} from "../../../../types/IOfferListOffer";

interface IProps {
    offers: IOfferListOffer[];
    dividerVisible: boolean;
}

export const ArchivedOffersListing = (props: IProps) => {
    return (
        <>
            <WideContent>
                {props.dividerVisible && (
                    <InfoPanel
                        icon={BrandTenementIcon}
                        heading="Zobacz wyprzedane oferty w tej lokalizacji."
                        subHeading="Te nieruchomości znalazły już swoich właścicieli."
                        css={[mt(6), mb(3)]}
                        headingAs="p"
                    />
                )}
            </WideContent>

            <ColumnList>
                {props.offers.map((offer, index) => {
                    return (
                        <ColumnListItem key={offer.id}>
                            <OfferBox
                                isArchived
                                offer={offer}
                                index={index}
                                gtmMeta={{
                                    listName: "Zobacz wyprzedane oferty w tej lokalizacji",
                                    listId: "zobacz_wyprzedane_oferty_w_tej_lokalizacji",
                                    source: "additional",
                                    tileEvents: {
                                        imageClick: offerBoxTracking.gtm.investAdditionalImageClick,
                                        buttonClick: offerBoxTracking.gtm.investAdditionalButtonClick,
                                        linkClick: offerBoxTracking.gtm.investAdditionalLinkClick,
                                        logoClick: offerBoxTracking.gtm.investAdditionalLogoClick
                                    }
                                }}
                            />
                        </ColumnListItem>
                    );
                })}
            </ColumnList>
        </>
    );
};
